export { default as DefaultPage } from './DefaultPage';
export { default as ContactUs } from './ContactUs';
export { default as PrivacyPolicy } from './PrivacyPolicy';
export { default as TermsAndConditions } from './TermsAndConditions';
export { default as About } from './About';
export { default as Partners } from './Partners';
export { default as Press } from './Press';
export { default as OurInvestors } from './OurInvestors';
export { default as TravelAgency } from './TravelAgency';



// WEBPACK FOOTER //
// ./src/features/pages/index.js